"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Signup/Setup/Sections/ReadyToGo/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _useStatefulPromise = require('shared/hooks/useStatefulPromise');
var _Form = require('web/components/Form');




var _components = require('web/screens/Signup/components');






/**
 * The final post-creation confirmation for net-new signups, rendered in the
 * authenticated continuation (OnboardingSteps) after the trial decision has
 * already created the account and org. Its action only navigates to the
 * inbox; `notice` surfaces a non-blocking degrade message (e.g. a failed
 * trial-checkout mint). A failed navigation renders an error + Retry surface.
 */
const ReadyToGoSection = ({ onComplete, notice }) => {
  const { isLoading, hasFailed, run } = _useStatefulPromise.useStatefulPromise.call(void 0, onComplete)

  const complete = () => { run().catch(() => { /* surfaced via hasFailed */ }) }

  if (isLoading) return _react2.default.createElement(_components.SignupStepLoader, {__self: this, __source: {fileName: _jsxFileName, lineNumber: 28}} )

  if (hasFailed) {
    return (
      _react2.default.createElement(_components.SignupStepError, {
        title: "Something went wrong"  ,
        desc: "We couldn't finish setting up your account. Please try again."         ,
        btnLabel: "Retry",
        onBtnClick: complete, __self: this, __source: {fileName: _jsxFileName, lineNumber: 32}}
      )
    )
  }

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement(_components.SignupStepHeader, {
        iconType: "ok",
        title: "You're all set!"  ,
        subtitle: "Your account is set up and ready. Head to your inbox to start using BloomText."              , __self: this, __source: {fileName: _jsxFileName, lineNumber: 43}}
      )
      ,  notice && _react2.default.createElement('p', { className: "auth-note", __self: this, __source: {fileName: _jsxFileName, lineNumber: 48}},  notice ) 
      , _react2.default.createElement(_Form.Button, { onClick: complete, __self: this, __source: {fileName: _jsxFileName, lineNumber: 49}}, "Go to my inbox"   )
    )
  )
}

exports. default = ReadyToGoSection
